interface ITrimRevertChanges {
  onCancel: () => void;
  revertChanges: any;
}

export default function TrimRevertChanges({ revertChanges, onCancel }: ITrimRevertChanges) {
  return (
    <div className="transparent font-lato">
      <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[520px] md:min-h-[100px] rounded-t-lg">
        <div className="flex mb-5">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Revert to original</span>
        </div>
        <p>All edits will be removed from your video. This cannot be undone.</p>
      </div>
      <div className="flex text-[13px] pb-6 px-4 bg-white rounded-b-lg border-x">
        <button
          className="py-3 px-8 text-black border border-tabBorder ml-auto rounded-[10px] hover:bg-gray-100"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="bg-red-main py-3 px-8 text-white ml-2 rounded-[10px]"
          onClick={async () => {
            await revertChanges();
            onCancel();
          }}
        >
          Remove
        </button>
      </div>
    </div>
  );
}
